import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';
import { generateHmacSignature } from 'src/app/utils/crypto-utils';

@Injectable({
  providedIn: 'root'
})
export class AiAssistantService {

  constructor(private http: HttpClient) { }

  async getTripChatLogs(tripId: string): Promise<Observable<any>> {
    const signature = await generateHmacSignature('{}', environment.HMAC_CONVERSATION_SECRET);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-hmac-signature': signature,
      'ngrok-skip-browser-warning': 'true'
    });

    return this.http.get<any>(
      urls.OUTBOUND_CONVERSATION_BASE_URL + urls.OUTBOUND_CONVERSATION + tripId,
      { headers }
    ).pipe(catchError(errorHandl));
  }

  async getRecording(post: any): Promise<Observable<any>> {
    const signature = await generateHmacSignature(JSON.stringify(post), environment.HMAC_CONVERSATION_SECRET);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-hmac-signature': signature
    });

    return this.http.post<any>(
      urls.OUTBOUND_CONVERSATION_BASE_URL + urls.OUTBOUND_CONVERSATION_RECORDING, post, { headers }
    ).pipe(catchError(errorHandl));
  }
}
